module.exports = __webpack_public_path__ + "static/media/sbg2.b6829490.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/active20/sbg2.png
// module id = 814
// module chunks = 0